module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P1"
  }, [_c('span', {
    staticClass: "size_160"
  }, [_c('span', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowle#page_xi"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduc#page_1"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "C94"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1_What_I#page_16"
    }
  }, [_vm._v("1. What Is Deep Rhetoric?")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1_What_I#id_233"
    }
  }, [_vm._v("What Is Rhetoric?")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1_What_I#id_234"
    }
  }, [_vm._v("Origins of Rhetoric")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1_What_I#id_235"
    }
  }, [_vm._v("Toward a Deep Rhetoric")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1_What_I#page_30"
    }
  }, [_vm._v("Some Theologies and Teleologies of Rhetoric")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1_What_I#id_236"
    }
  }, [_vm._v("Suspecting Universality")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1_What_I#id_237"
    }
  }, [_vm._v("Deep Rhetoric and Big Rhetoric")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1_What_I#id_238"
    }
  }, [_vm._v("Rhetoric and Humanism")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1_What_I#id_239"
    }
  }, [_vm._v("Rhetorical Capabilities")])])]), _vm._v(" "), _c('p', {
    staticClass: "C94"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_2_What_I#page_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. What Is Deep Rhetoric? II")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/08_2_What_I#id_240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetoric and Ideology")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/08_2_What_I#id_241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Deep Rhetoric of the Late Twentieth Century")])])]), _vm._v(" "), _c('p', {
    staticClass: "C94"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3_The_De#page_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Deep Rhetoric of Plato’s "), _c('em', [_vm._v("Gorgias")])])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3_The_De#id_242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Rhetoric: An Overview")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3_The_De#id_243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plato and the Sophists")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3_The_De#id_244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gorgias")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3_The_De#id_245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gorgias/Callicles")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3_The_De#id_246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Failure of Transcendence: Rhetoric and Narcissism")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3_The_De#id_247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Rhetorical")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09_3_The_De#id_247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nomos "), _c('em', [_vm._v("and the Care of the Soul")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3_The_De#id_248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Kinds of Rhetoric: A Deep Rhetorical Critique")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3_The_De#id_249",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("The")]), _vm._v(" Ethical Ontology of Deep Rhetorical Decorum")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3_The_De#id_250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Logos")])]), _vm._v(" "), _c('p', {
    staticClass: "C94"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_4_Rhetor#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Rhetoric and Violence")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/10_4_Rhetor#id_251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rhetorical Origin of Human Sociality: The Great Myth of Protagoras")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/10_4_Rhetor#id_273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetoric Is Violence: Walter Benjamin")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/10_4_Rhetor#id_252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Rhetoric: Otherwise Than Violence")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/10_4_Rhetor#id_253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suffering Violence")])])]), _vm._v(" "), _c('p', {
    staticClass: "C94"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5_Throug#page_174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Through Heidegger: Transcendence and Logos")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5_Throug#id_254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heidegger")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5_Throug#id_255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("World and Logos")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5_Throug#page_205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Understanding, Interpretation, and Meaning")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5_Throug#id_256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Assertion")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5_Throug#id_257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Logos and Discourse")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5_Throug#page_217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transcendence: Grounds and Reasons")])])]), _vm._v(" "), _c('p', {
    staticClass: "C94"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_6_Beyond#page_225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Beyond Heidegger: False Trails and Re-readings")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_6_Beyond#id_258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solus Ipse "), _c('em', [_vm._v("v. Logos")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_6_Beyond#id_259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silence and the Diminishment of Logos")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_6_Beyond#id_260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beyond Reason")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_6_Beyond#id_261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghostly Other")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_6_Beyond#id_262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Re-reading Heidegger")])])]), _vm._v(" "), _c('p', {
    staticClass: "C94"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_7_Reason#page_262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Reason and Justice: The Deep Rhetorical Dimensions of the New Rhetoric Project")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_7_Reason#id_263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep Rhetoric and Justice")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_7_Reason#id_264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reconstructing")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_7_Reason#id_264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Rhetoric")])]), _vm._v(" "), _c('p', {
    staticClass: "C94"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_8_Rhetor#page_315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Rhetoric and Wisdom")])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_8_Rhetor#id_265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wisdom in the Rhetorical Tradition")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_8_Rhetor#id_266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Origin of Rhetoric in the")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14_8_Rhetor#id_266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oresteia "), _c('em', [_vm._v("of Aeschylus")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_8_Rhetor#page_323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Prajnaparamita Sutras")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_8_Rhetor#id_267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hebrew Wisdom")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_8_Rhetor#id_268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Socratic Wisdom")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_8_Rhetor#id_269",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Burkean")]), _vm._v(" Wisdom")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_8_Rhetor#id_270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Rhetorical Wisdom")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_8_Rhetor#id_271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Athena’s Practical Wisdom")])])]), _vm._v(" "), _c('p', {
    staticClass: "C95"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_8_Rhetor#id_272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After Athena")])])]), _vm._v(" "), _c('p', {
    staticClass: "C94"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Notes#page_371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Works_Ci#page_389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Works Cited")])])]), _vm._v(" "), _c('p', {
    staticClass: "C114"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Index#page_403",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb521b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 66
// module chunks = 0